import React from 'react';
import Main from './Main';
import styled from 'styled-components';
import stepStore from '../../../store/step';
// import logo from '../../../imges/settled/logo.png';
import bg from '../../../imges/settled/settled-bg.png';
import title from '../../../imges/settled/settled-title.png';
// import paper from '../../../imges/settled/paper.png';
import { Provider } from 'mobx-react';

export default function () {
  return (
    <Container>
      {/* <header></header> */}
      {/* <Desc>
        <span>商家入驻</span>
        <span>简单的几个步骤完成入驻申请</span>
      </Desc> */}
      <Provider stepStore={stepStore}>
        <Main />
      </Provider>
      {/* <Mobile>
        违法和不良信息公开举报电话：0571-86136192
      </Mobile> */}
    </Container>
  )
}

const Container = styled.section`
  background: url(${bg}) no-repeat center 0;
  background-size:  cover;
  height: 768px;
  /* header{
    height:482px;
    background: url(${title}) no-repeat 484px 224px, url(${bg}) no-repeat center 0;
    background-size:  172px 40px, 2560px 482px;
  } */
`

// const Desc = styled.div`
//   margin: 0 auto;
//   width: 1160px;
//   height: 222px;
//   background: url(${paper}) no-repeat right 0 bottom 2px;
//   background-size: 193px 134px;
//   padding-top: 83px;
//   box-sizing: border-box;
//   span:first-child{
//     font-size:20px;
//     font-weight:bold;
//     color:rgba(54,54,54,1);
//     line-height:25px;
//     margin-bottom: 9px;
//     display: block;
//   }
//   span:nth-child(2){
//     font-size:16px;
//     font-weight:400;
//     color:rgba(104,104,104,0.8);
//     line-height:22px;
//   }
// `

// const Mobile = styled.div`
//     position: fixed;
//     bottom: 0;
//     height: 50px;
//     line-height: 50px;
//     right: 0;
//     left: 0;
//     text-align: center;
//     color: rgba(176,176,186,1);
// `